import React from 'react';
import {
    StyledTableCell,
    StyledTableRow,
} from '../../ui/StockInfoTable/styledTableComponents';
import Blockies from 'react-blockies';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import {
    getCellToDisplay,
    getHeaderRowFromSchema,
} from '../../ui/StockInfoTable/stockTableUtils';

export const LeaderboardSchema = [
    {
        name: 'rank',
        label: 'Rank',
        showMobile: false,
        showIfTournamentHasStarted: true,
        showIfTournamentHasNotStarted: true,
        showIfHomePage: true,
    },
    {
        name: 'userName',
        label: 'Player',
        showMobile: true,
        showIfTournamentHasStarted: true,
        showIfTournamentHasNotStarted: true,
        showIfHomePage: true,
    },
    {
        name: 'totalAccountValue',
        label: 'Points',
        showMobile: true,
        showIfTournamentHasStarted: true,
        showIfTournamentHasNotStarted: true,
        showIfHomePage: true,
    },
    {
        name: 'maxAccountValue',
        label: 'Max',
        showMobile: false,
        showIfTournamentHasStarted: true,
        showIfTournamentHasNotStarted: true,
        showIfHomePage: false,
    },
];

export function getUserRow(userInfo, rank, mobile, homePage, isFixedUser) {
    return (
        <tr
            style={{
                borderBottom: isFixedUser ? '2px solid rgb(59, 130, 246, 0.5)' : undefined,
            }}
            className="cursor-pointer text-white border-b border-slate-800/50 hover:bg-slate-900/50 transition-colors"
            onClick={() => {
                window.location.href = `${ROUTES.USERS}/${userInfo.userName}`;
            }}
        >
            {getCellToDisplay(
                mobile,
                LeaderboardSchema.find((x) => x.label === 'Rank'),
                rank
            )}
            {getCellToDisplay(
                mobile,
                LeaderboardSchema.find((x) => x.label === 'Player'),
                <Link
                    to={`${ROUTES.USERS}/${userInfo.userName}`}
                    className="inline-flex items-center gap-2.5 justify-center"
                >
                    <Blockies
                        seed={userInfo.userName}
                        size={8}
                        scale={3}
                        className="rounded-md flex-shrink-0"
                    />
                    <span className="font-semibold text-sm">{userInfo.userName}</span>
                </Link>
            )}
            {getCellToDisplay(
                mobile,
                LeaderboardSchema.find((x) => x.label === 'Points'),
                userInfo.totalAccountValue.toFixed(0)
            )}
            {getCellToDisplay(
                mobile,
                LeaderboardSchema.find((x) => x.label === 'Max'),
                userInfo.maxAccountValue
                    ? userInfo.maxAccountValue.toFixed(0)
                    : 0,
                homePage
            )}
        </tr>
    );
}

//gets all rows for all users and account values
export function getRows(leaderboard, mobile, page, username, homePage) {
    let PAGE_SIZE = 25;

    if (!leaderboard || !Array.isArray(leaderboard)) {
        return (
            <StyledTableRow>
                <StyledTableCell colSpan={4}>No data available</StyledTableCell>
            </StyledTableRow>
        );
    }

    let index = 0;
    const userInfo = leaderboard.find((user, i) => {
        if (user && user.userName === username) {
            index = i;
            return true;
        }
        return false;
    });

    return (
        <>
            {userInfo && (
                <>{getUserRow(userInfo, index + 1, mobile, homePage, true)}</>
            )}

            {leaderboard.map((row, i) => {
                if (i < (page - 1) * PAGE_SIZE || i >= page * PAGE_SIZE) {
                    return <></>;
                }

                if (!row) return <></>;

                return <>{getUserRow(row, i + 1, mobile, homePage)}</>;
            })}
        </>
    );
}

//gets the leaderboard header row
export function getHeaderRow(mobile, homePage) {
    return getHeaderRowFromSchema(
        LeaderboardSchema,
        undefined,
        undefined,
        undefined,
        mobile,
        homePage
    );
}
